import { api, getSyncInfo } from "./storage.js";

export function bindPresence(publicSession = null) {
  let busy = false;
  async function heartbeat() {
    if (busy || document.visibilityState !== "visible" || !navigator.onLine)
      return;
    const { session, requiresLogin } = publicSession
      ? { session: publicSession, requiresLogin: false }
      : getSyncInfo();
    if (!session?.csrf || requiresLogin) return;
    busy = true;
    try {
      if (publicSession) {
        const response = await fetch("/api/presence", {
          method: "POST",
          credentials: "same-origin",
          cache: "no-store",
          signal: AbortSignal.timeout(10000),
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": session.csrf,
          },
          body: JSON.stringify({ page: location.pathname }),
        });
        if (response.status === 403) {
          const next = await fetch("/api/session", {
            credentials: "same-origin",
            cache: "no-store",
            signal: AbortSignal.timeout(10000),
          });
          if (next.ok) publicSession = await next.json();
        }
      } else {
        await api("/api/presence", {
          method: "POST",
          data: { page: location.pathname },
        });
      }
    } catch {
      // Presence is best effort; planner saves must not depend on it.
    } finally {
      busy = false;
    }
  }
  heartbeat();
  setInterval(heartbeat, 30_000);
  document.addEventListener("visibilitychange", heartbeat);
  window.addEventListener("online", heartbeat);
  window.addEventListener("popstate", heartbeat);
  window.addEventListener("planner:sync", heartbeat);
}
